import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import type { OrganizationAttendee } from 'services/api';
import { formatPeopleDate } from '../formatPeopleDate';
import { AttendeeRolePill } from './AttendeeRolePill';
import { EngagementPill } from './EngagementPill';

const TEXT_COLOR = '#383838';
const ROW_BORDER = '#DEDEDE';

export function AttendeesMobileCards ({
  attendees,
}: {
  attendees: OrganizationAttendee[];
}): ReactElement {
  return (
    <Box sx={{ width: '100%', pb: '24px' }}>
      {attendees.map((a, idx) => {
        const isLast = idx === attendees.length - 1;
        return (
          <Box
            key={a.userId}
            component="button"
            type="button"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              width: '100%',
              padding: '16px 0',
              cursor: 'pointer',
              backgroundColor: 'transparent',
              textAlign: 'left',
              borderWidth: 0,
              borderTopWidth: 1,
              borderBottomWidth: isLast ? 1 : 0,
              borderStyle: 'solid',
              borderColor: ROW_BORDER,
            }}
          >
            <Box display="flex" flexDirection="column" gap="16px" alignItems="flex-start" width="100%">
              <Box display="flex" gap="16px" alignItems="center" width="100%">
                <Box flex={1} minWidth={0}>
                  <Typography
                    sx={{
                      fontFamily: '\'Poppins\', sans-serif',
                      fontSize: '14px',
                      fontWeight: 500,
                      lineHeight: '24px',
                      color: TEXT_COLOR,
                    }}
                  >
                    {a.firstName} {a.lastName}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: '\'Poppins\', sans-serif',
                      fontSize: '11px',
                      fontWeight: 400,
                      lineHeight: '18px',
                      color: TEXT_COLOR,
                    }}
                  >
                    {a.schoolEmail}
                  </Typography>
                </Box>
                <ChevronRightIcon sx={{ fontSize: 24, color: TEXT_COLOR, flexShrink: 0 }} />
              </Box>

              <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" gap="8px">
                <Box display="flex" alignItems="center" gap="8px" flexWrap="wrap">
                  {a.role ? <AttendeeRolePill role={a.role} /> : null}
                  <EngagementPill engagement={a.engagement} />
                </Box>
                <Typography
                  sx={{
                    fontFamily: '\'Poppins\', sans-serif',
                    fontSize: '12px',
                    fontWeight: 400,
                    color: TEXT_COLOR,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {a.attendedCount}/{a.totalEvents} · {Math.round(a.attendedPercent)}%
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontFamily: '\'Poppins\', sans-serif',
                  fontSize: '11px',
                  fontWeight: 400,
                  lineHeight: '18px',
                  color: TEXT_COLOR,
                }}
              >
                Last attended: {formatPeopleDate(a.lastAttended)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
